export default __webpack_public_path__ + "static/media/cream-black.37c01508.svg";